import React from 'react';

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    title?: string;
    containerClassName?: string;
    error?: string;
}

export default function Textarea({ title, containerClassName = '', className = '', error, ...props }: TextareaProps) {
    return (
        <div className={`flex flex-col gap-1 ${containerClassName}`}>
            {title && (
                <label htmlFor={props.id} className="block text-secondary font-semibold">
                    {title}
                    {props.required && <span className="text-red-500 ml-0.5">*</span>}
                </label>
            )}
            <textarea
                className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-[#151515] focus:border-[#151515] outline-none transition-colors bg-gray-50 focus:bg-white placeholder-[#52525B] resize-none text-[14px] ${
                    error ? 'border-red-500' : 'border-[#D2D2D2]'
                } ${className}`}
                {...props}
            />
            {error && <span className="text-[11px] font-medium text-red-500">{error}</span>}
        </div>
    );
}

export type { TextareaProps };
